<template>
   <b-modal id="modalAddCategory" modal-class="modal-fullscreen" title="Voeg een categorie toe" hide-backdrop
      size="md"
      @show="focusInput"
      @hidden="cleanupModal"
      @ok="handleCategoryModalOk">
      <b-form ref="categoryForm" @submit.stop.prevent="modalAddCategorySubmit()" >
        <b-form-group label="naam:" :invalid-feedback="naamInvalidInfo" :state="naamState">
          <b-form-input ref="inputNaam" class="col-6 px-1 px-sm-2" required :state="naamState"
            v-model="newCategory.naam" />
        </b-form-group>
      </b-form>
   </b-modal>
</template>
<script>

import db from "../db.js"

export default {
   name:"modal-add-category",
   props: ["userID", "categories"],
   data: function() {
      return {
         naamState: null,
         naamInvalidInfo: "Deze naam kan niet toegevoegd worden",
         newCategory: {id:null ,naam: ""}
      };
   },
   computed: {
      categoryId: function() {
         return (this.newCategory.naam
         .toLowerCase()
         .replace(/[^\w ]+/g, '')
         .replace(/ +/g, '-') + "-" + this.now)
      },
      now: function() {
         var date = new Date();
         return (
            String (date.getHours()) +
            String (date.getMinutes()) +
            String (date.getSeconds())
         )
      },
   },
   methods: {
    focusInput: function() {
      setTimeout(() => {
          this.$refs.inputNaam.focus()
      },500)
    },
      handleCategoryModalOk: function(bvModalEvent) {
         bvModalEvent.preventDefault();
         this.modalAddCategorySubmit();
      },
      handleCancel: function() {
         this.newCategory = {id:null ,naam: ""}
      },
      /**
       * 1) check of het veld naam is ingevuld
       * 2) check (hoofdletter-ongevoelig) of de categorie niet al bestaat
       * 3) voeg de categorie toe onder users/{uid}/categories
       * 4) emit 'categoryCreated' met de naam zodat de dropdown erop kan matchen
       * 5) sluit het venster
       */
      modalAddCategorySubmit: function() {
         this.naamState = true
         this.$refs.categoryForm.checkValidity()
         this.newCategory.naam = this.newCategory.naam.trim()
         if(this.newCategory.naam == "") {
            this.naamState = false;
            this.naamInvalidInfo = "Geef een naam op"
         } else {
            for (let i = 0; i < this.categories.length; i++) {
               const cat = this.categories[i];
               if(cat.text && cat.text.toLowerCase() == this.newCategory.naam.toLowerCase()) {
                  this.naamInvalidInfo = "Categorie bestaat al"
                  this.naamState = false;
                  break;
               }
            }
         }
         if(!this.naamState ) {
            return
         }
         this.newCategory.id = this.categoryId
         var createdName = this.newCategory.naam
         const catRef = db.collection("users").doc(this.userID).collection("categories").doc(this.newCategory.id)
         catRef.set(this.newCategory).then(()=>{
               //no need to add to categories: the onSnapshot in App.vue will add it to the clients categories array
               this.$emit("categoryCreated", createdName)
               this.$nextTick(()=> {
                  this.$bvModal.hide('modalAddCategory')
               })
         })
         .catch(error => {
            console.log(error)
         })
      },
      cleanupModal: function() {
            this.newCategory = {id:null ,naam: ""}
      }
   },
}
</script>
